<!--
 * @Author: your name
 * @Date: 2021-05-19 17:07:01
 * @LastEditTime: 2021-09-15 18:21:35
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \epec-ope\src\views\content\yirongtongShop\components\yrtBanner.vue
-->
<template>
  <section class="control_box">
  <!-- 新增/编辑广告图 -->
<el-dialog  :append-to-body="true" title="广告图管理"  :visible.sync="dialogVisible" width="600px" @close='closeDialog'>
  <el-form :model="formData" :rules="rules" ref="ruleForm"  label-width="100px">
    <el-form-item label="广告图:" prop="imgUrl">
       <el-upload
          class="oneimg-upload"
          :action="uploadImgUrl"
          :headers="header"
          :show-file-list="false"
          :before-upload="beforeImgUpload"
          :on-success="handleImgSuccess"
          accept=".jpeg,.jpg,.png">
          <el-image v-if="formData.imgUrl" :src="formData.imgUrl" fit="fill" ></el-image>
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
    </el-form-item>
    <el-form-item label="跳转链接:"  >
      <el-input v-model.trim="formData.linkUrl"></el-input>
    </el-form-item>
  </el-form>
  <div class="tip-list">
          <p>1.广告图图片宽高为1200px×140px，仅可上传1张，仅支持上传.jpg/.jpeg/.png格式的图片，大小不 超过1M。</p>
          <p>2.跳转链接请直接从易派客前台相关页面复制，域名开头必须为https://XXXXXX.epec.com。</p>
      </div>
  <div slot="footer" class="dialog-footer flex-c">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
  </div>
</el-dialog>
  <!-- 新增/编辑广告图 -->
  </section>
</template>

<script> 
import { epecToken } from "../../utils/globalData";
import api from '../../api/cms/index'
import utils from "../..//utils/utils";
export default {
     props:{
        activeName: {
            type: String,
            default: ''
        },
         advertisementData: {
          type: Object,
          default: function () {
            return {
                isHidden:false,
                advertisementList:[]
            }
          }
        },
        
  },
  watch: {
        activeName(newV,oldV) {
            console.log(oldV)
            this.dialogVisible= newV=='advertisement'?true:false
            if(this.advertisementData.advertisementList.length==0){
              this.formData.imgUrl='';
              this.formData.linkUrl='';
            }else{
              this.formData=this.advertisementData.advertisementList[0]
            }
        } 
  },
    data(){
      
      return {
        header:epecToken,
        dialogVisible:false,
        rules: {
          imgUrl: [
            { required: true, message: '请上传广告图', trigger: 'blur' }
          ],
        },
     
        formData:{
          imgUrl:'',
          linkUrl:'',
        }
      }
    },
    created(){
      this.uploadImgUrl=api.fileUpload
    },
    methods:{
      closeDialog(){
          this.$parent.choosenComments('');
      },
      handleImgSuccess(res, file) {
          console.log(file)
          if(res.success){
              this.formData.imgUrl=res.data.url;
              this.$message.success('上传成功！');
          }
      },
      beforeImgUpload(file) {
          const isMaxsize = file.size / 1024 / 1024 < 1;
          let parmas={
              file:file,
              typeArr:['image/jpeg', 'image/png'],
              imgMessage:'上传图片只能是jpg或者png格式!',
              isMaxsize:isMaxsize,
              sizeMessage:'上传图片大小不能超过1M!',
              maxWidth:1200,
              maxHeight:140
          }
          return utils.checkImgupload(parmas)
      },
    
       submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
          if(this.advertisementData.advertisementList.length==0){
            this.advertisementData.advertisementList.push({...this.formData})
          }else{
            this.advertisementData.advertisementList.splice(0, 1, {...this.formData});
          }
            
            this.dialogVisible=false;
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
    }
}
</script>

<style lang='scss' scoped>
@import '../../../../assets/css/theme.scss';
.control_box{
 
  background: #fff;
  .box-card-header{
    font-weight: 600;
  
  }
  

  
  
}
.tip-list{
  background: #F4F7FF;
  padding:10px;
  margin-top: 10px;
  p{
    color:$c6;
    line-height: 32px;
  }
}
.oneimg-upload{
    width: 389px;
    background-color: #fff;
    border-radius: 6px;
    box-sizing: border-box;
    text-align: center;
    cursor: pointer;
  }
  .oneimg-upload ::v-deep .el-upload--text{
    width: 387px;
    height:180px;
    line-height: 180px;
    border: 1px dashed #d9d9d9;
    .el-image{
      height:100%;
    }
  }
</style>

 
